// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-common-ErrorContent-module__root--2pXD0","content":"src-components-common-ErrorContent-module__content--1Djw3"};